export const uniqueSorted = (values) =>
  [...new Set(values.filter((value) => value != null && value !== ""))].sort(
    (left, right) => String(left).localeCompare(String(right)),
  );

export const INVENTORY_KPI = {
  TOTAL: "total",
  AVAILABLE: "available",
  SHORT: "short",
  NOT_AVAILABLE: "not_available",
  DATA_NOT_AVAILABLE: "data_not_available",
};

export const INVENTORY_STATUS = {
  AVAILABLE: "Inventory Available",
  SHORT: "Inventory Short",
  NOT_AVAILABLE: "Inventory Not Available",
  DATA_NOT_AVAILABLE: "Inventory Data Not Available",
  SPLIT: "Inventory Split Across Warehouses",
};

export const isAvailableInventoryStatus = (status) =>
  status === INVENTORY_STATUS.AVAILABLE ||
  (typeof status === "string" && status.startsWith("Available at "));

export const isShortInventoryStatus = (status) =>
  status === INVENTORY_STATUS.SHORT || status === INVENTORY_STATUS.SPLIT;

export const sameInventoryStatusSet = (left = [], right = []) => {
  if (left.length !== right.length) return false;
  const rightSet = new Set(right);
  return left.every((value) => rightSet.has(value));
};

export const inventoryStatusesForKpi = (
  kpi,
  inventoryStatusOptions = [],
) => {
  if (kpi === INVENTORY_KPI.AVAILABLE) {
    const matched = uniqueSorted(
      inventoryStatusOptions.filter(isAvailableInventoryStatus),
    );
    return matched.length ? matched : [INVENTORY_STATUS.AVAILABLE];
  }
  if (kpi === INVENTORY_KPI.SHORT) {
    const matched = uniqueSorted(
      inventoryStatusOptions.filter(isShortInventoryStatus),
    );
    return matched.length ? matched : [INVENTORY_STATUS.SHORT];
  }
  if (kpi === INVENTORY_KPI.NOT_AVAILABLE) {
    return [INVENTORY_STATUS.NOT_AVAILABLE];
  }
  if (kpi === INVENTORY_KPI.DATA_NOT_AVAILABLE) {
    return [INVENTORY_STATUS.DATA_NOT_AVAILABLE];
  }
  return [];
};

export const activeInventoryKpi = (
  inventoryStatuses = [],
  inventoryStatusOptions = [],
) => {
  if (!inventoryStatuses.length) return INVENTORY_KPI.TOTAL;
  const kpis = [
    INVENTORY_KPI.AVAILABLE,
    INVENTORY_KPI.SHORT,
    INVENTORY_KPI.NOT_AVAILABLE,
    INVENTORY_KPI.DATA_NOT_AVAILABLE,
  ];
  return (
    kpis.find((kpi) =>
      sameInventoryStatusSet(
        inventoryStatuses,
        inventoryStatusesForKpi(kpi, inventoryStatusOptions),
      ),
    ) || null
  );
};

export const nextInventoryStatusesForKpiClick = (
  kpi,
  currentInventoryStatuses = [],
  inventoryStatusOptions = [],
) => {
  if (kpi === INVENTORY_KPI.TOTAL) return [];
  const next = inventoryStatusesForKpi(kpi, inventoryStatusOptions);
  return sameInventoryStatusSet(currentInventoryStatuses, next) ? [] : next;
};

export const filterExceptionOrders = (
  orders = [],
  {
    orderId = "",
    statuses = [],
    sources = [],
    warehouses = [],
    inventoryStatuses = [],
  } = {},
) => {
  const needle = String(orderId || "")
    .trim()
    .toLowerCase();
  return (orders || []).filter((order) => {
    if (needle && !String(order.order_id || "").toLowerCase().includes(needle)) {
      return false;
    }
    if (statuses.length && !statuses.includes(order.status)) {
      return false;
    }
    if (sources.length && !sources.includes(order.source || "")) {
      return false;
    }
    if (warehouses.length && !warehouses.includes(order.warehouse || "")) {
      return false;
    }
    if (
      inventoryStatuses.length &&
      !inventoryStatuses.includes(order.inventory_status)
    ) {
      return false;
    }
    return true;
  });
};

export const exceptionFilterOptions = (orders = []) => ({
  statuses: uniqueSorted(orders.map((order) => order.status)),
  sources: uniqueSorted(orders.map((order) => order.source || "")),
  warehouses: uniqueSorted(orders.map((order) => order.warehouse || "")),
  inventoryStatuses: uniqueSorted(
    orders.map((order) => order.inventory_status),
  ),
});
